module.exports = __webpack_public_path__ + "img/p__华北电力.3e17ee84.png";